import { render, staticRenderFns } from "./OpeningPeriod.vue?vue&type=template&id=13bef92a"
import script from "./OpeningPeriod.vue?vue&type=script&lang=js"
export * from "./OpeningPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports